var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-switch=\"mode\"><div ng-switch-when=\"edit\"><h4 ng-bind-html=\"field_label | to_trusted\"></h4><input type=\"{{type}}\" name=\"{{field.name}}\" ng-required=\"field.required\" ng-model=\"field.value\" ui-mask=\"999-99-9999\" class=\"form-control ssn-input\"><div ng-show=\"!hijack\" ng-click=\"toggleShow()\" class=\"show-button\">{{ type === 'password' ? 'show' : 'hide'}}</div></div><div ng-switch-when=\"view\"><div ng-class=\"{white: (index + 1) % 2 == 0}\" class=\"colorcont clearfix\"><div class=\"left disable\"><p ng-bind-html=\"field.label | to_trusted\"></p></div><div class=\"right\"><p class=\"ssn-value\">{{field.value}}<a ui-sref=\"root.home.applicant_ssn\" style=\"margin-left: 5px\" ng-if=\"show_explanation\" target=\"_blank\"><i class=\"fa fa-question-circle\"></i></a></p></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/ssn/ssn.jade
// module id = 376
// module chunks = 0